export default {
  path: '/heroes',
  name: 'heroes',
  component: () => import('./Heroes.view.vue'),
};
